import React from "react";
import { string, bool, object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import TagStorySearch from "../../../molecules/TagStorySearch";
import DfpAd from "../../../dfp-ad";

import "./organism3.m.css";

const Organism3 = ({ className = "", isSectionComponent, widgetUrl = null, collectionSlug, publisherAttributes }) => {
  return (
    <div styleName="base" className={className}>
      <div styleName="ad-slot">
        <DfpAd
          adtype={
            isSectionComponent
              ? publisherAttributes.lang === "en"
                ? "EnPalo_ROS_336x280_R1"
                : "News_336x280_R1"
              : publisherAttributes.lang === "en"
              ? "EnPalo_HP_300x250_R3"
              : "Home_336x280_R3"
          }
          collectionSlug={collectionSlug}
        />
      </div>
      {isSectionComponent ? (
        widgetUrl && (
          <div styleName="widget-wrapper">
            <iframe src={widgetUrl} styleName="widget-iframe"></iframe>
          </div>
        )
      ) : (
        <TagStorySearch className="tag-story" />
      )}
    </div>
  );
};

Organism3.propTypes = {
  className: string,
  isSectionComponent: bool,
  widgetUrl: string,
  collectionSlug: string,
  publisherAttributes: object
};

const mapStateToProps = state => {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
  };
};

export default connect(mapStateToProps, null)(Organism3);
